import PropTypes from 'prop-types';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useApplicationUid from '../hooks/useApplicationUid';
import {
  getMetalStreamGoldProducts,
  getMetalStreamSilverProducts,
} from '../store/actions/metalStream/metalStreamActions';
import {
  selectMetalStreamGoldProducts,
  selectMetalStreamSilverProducts,
} from '../store/selectors/metalStreamSelectors';
import ProductsList from './ProductCard/ProductsList';
import useGtmStepHook from '../util/hooks/useGtmStepHook';
import { ACCOUNT_STEP_VIEW } from '../util/gtmEvents';
import { gtmStepHelper } from '../util/helpers/gtmHelper';

const MetalStreamForm = ({
  nextPath,
  skipStepPath,
  productType,
  onModalClose,
}) => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();
  const metalStreamProducts = useSelector(
    productType === 'Gold'
      ? selectMetalStreamGoldProducts
      : selectMetalStreamSilverProducts,
  );

  const { gtmStepEvent } = useGtmStepHook();

  useEffect(() => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel:
        productType === 'Gold'
          ? 'MetalStream choose gold'
          : 'MetalStream choose silver',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (productType === 'Gold') {
      dispatch(
        getMetalStreamGoldProducts({
          ApplicationUid,
        }),
      );
    }

    if (productType === 'Silver') {
      dispatch(
        getMetalStreamSilverProducts({
          ApplicationUid,
        }),
      );
    }
  }, [ApplicationUid, dispatch, productType]);

  return (
    <>
      <ProductsList
        productType={productType}
        products={metalStreamProducts}
        nextPath={nextPath}
        skipStepPath={skipStepPath}
        onModalClose={onModalClose}
      />
    </>
  );
};

MetalStreamForm.propTypes = {
  nextPath: PropTypes.string,
  productType: PropTypes.string,
  onModalClose: PropTypes.func,
  skipStepPath: [PropTypes.string],
};

export default MetalStreamForm;
